module.exports = __webpack_public_path__ + "assets/img/EnrichMarket.1333eb0e.png";